import React, { Component } from "react";
//import ReactObserver from "react-event-observer";

class NavigationPane extends Component {
  state = {
    items: []
  };
  constructor(props) {
    super(props);
    this.observer = props.observer;
  }
  render() {
    return (
      <div id="all-questions" className="wide">
        <div className="table-of-contents">
          <nav>
            <ul>
              {
                /* {this.props.items.map(block => (
                <a
                  key={block.id}
                  onClick={() => this.navigateToBlock(block.id)}
                >
                  <li className={this.getItemClass(block)}>{block.title}</li>
                </a>
              ))} */
                this.state.items
              }
            </ul>
          </nav>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.setState({
      items: this.structureNavigationItems(
        this.props.items,
        this.props.selected
      )
    });
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      items: this.structureNavigationItems(newProps.items, newProps.selected)
    });
  }

  structureNavigationItems(items, selected) {
    let visualItems = [];
    if (items) {
      items.forEach(block => {
        visualItems.push(
          <a
            key={block.id}
            onClick={() => this.navigateToBlock(block.id)}
            href={"#" + block.title}
          >
            <li className={this.getItemClass(block, selected)}>
              {block.title}
            </li>
          </a>
        );
      });
    }

    return visualItems;
  }

  navigateToBlock = id => {
    this.observer.publish("scroll", id);
  };

  getItemClass(block, selected) {
    let className = "toc";
    if (selected === block.id) {
      className += " active";
    }

    return className;
  }
}

export default NavigationPane;
